export enum Role {
  FREE = 'free',
  ADMIN = 'admin',
  USER = 'user',
  LINUX_ADMIN = 'admin_linux',
  ANDROID_ADMIN = 'admin_android',
  FORKLIFT_ADMIN = 'admin_forklift',
  FORKLIFT_USER = 'forklift_user',
}
